'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { AppLayoutContext } from '#pplx/frontend/apps/ask/layout/primitives/AppLayoutContext.js';
import { useState } from 'react';
export const AppLayoutProvider = ({ children }) => {
    const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
    return (_jsx(AppLayoutContext.Provider, { value: { isMobileSidebarOpen, setMobileSidebarOpen }, children: children }));
};
//# sourceMappingURL=AppLayoutProvider.js.map